"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.definePinoLogHandlers = void 0;
var _SeverityLevels = require("../../types/SeverityLevels");
var definePinoLogHandlers = function(handlers) {
    return function(message) {
        switch(message.level){
            case _SeverityLevels.SeverityLevels.INFO:
                var _handlers_onInfo;
                (_handlers_onInfo = handlers.onInfo) === null || _handlers_onInfo === void 0 ? void 0 : _handlers_onInfo.call(handlers, message);
                break;
            case _SeverityLevels.SeverityLevels.METRIC:
                var _handlers_onMetric;
                (_handlers_onMetric = handlers.onMetric) === null || _handlers_onMetric === void 0 ? void 0 : _handlers_onMetric.call(handlers, message);
                break;
            case _SeverityLevels.SeverityLevels.ERROR:
                var _handlers_onError;
                (_handlers_onError = handlers.onError) === null || _handlers_onError === void 0 ? void 0 : _handlers_onError.call(handlers, message);
                break;
            case _SeverityLevels.SeverityLevels.WARN:
                var _handlers_onWarn;
                (_handlers_onWarn = handlers.onWarn) === null || _handlers_onWarn === void 0 ? void 0 : _handlers_onWarn.call(handlers, message);
                break;
            case _SeverityLevels.SeverityLevels.DEBUG:
                var _handlers_onDebug;
                (_handlers_onDebug = handlers.onDebug) === null || _handlers_onDebug === void 0 ? void 0 : _handlers_onDebug.call(handlers, message);
                break;
            default:
                // eslint-disable-next-line no-console -- it's okay here
                console.warn("Unknown message level: ".concat(message.level));
        }
    };
};
exports.definePinoLogHandlers = definePinoLogHandlers; //# sourceMappingURL=definePinoLogHandlers.js.map
